import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';

export class SetStepCommand implements ICommand {
  private readonly _viewsService: ViewsService;

  private _targetView: ViewEntity;

  private _previousView: ViewEntity | null = null;

  public constructor(viewsService: ViewsService, view: ViewEntity) {
    this._viewsService = viewsService;
    this._targetView = view;
  }

  public execute(): Promise<boolean> {
    this._previousView = this._viewsService.currentView;
    this._viewsService.setCurrentView(this._targetView);
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (this._previousView) {
      this._viewsService.setCurrentView(this._previousView);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
}
